






















import Vue from 'vue';
import { Scenario } from '../model';
import { VarNum, InputMode } from '../model';
import OneScenario from './OneScenario.vue';

let nextIndex = 0;

export default Vue.extend({
  components: {
    OneScenario,
  },

  data() {
    return {
      scenarios: [
        new Scenario(nextIndex++),
        new Scenario(nextIndex++),
        new Scenario(nextIndex++),
        new Scenario(nextIndex++),
        new Scenario(nextIndex++),
      ] as Scenario[],
      tabs: 'tab-0',
    };
  },

  created() {
    // Pre-configure some scenarios
    this.scenarios[0].title = 'House';

    const s1 = this.scenarios[1];
    s1.title = 'Rent';
    s1.price = 0;
    s1.outfitting = 0;
    s1.buyCostFlat = 0; s1.buyCostPct = 0;
    s1.sellCostFlat = 0; s1.sellCostPct = 0;
    s1.propertyTax = 0;
    s1.utilities -= 100;
    s1.insurance /= 1.5;
    s1.maintenance = 0;
    s1.rent = 1200;

    // A lot of these are guesses
    const s2 = this.scenarios[2];
    s2.title = 'Condo';
    s2.price = 200000;
    s2.outfitting = 0;
    s2.buyCostFlat -= 200;
    s2.propertyTax = 1500;
    s2.condoFees = 280;
    s2.utilities -= 60;
    s2.insurance -= 30;
    s2.maintenance = 400;
    s2.rent = 0;

    const s3 = this.scenarios[3];
    s3.title = 'Townhouse';
    s3.price = 220000;
    s3.outfitting -= 200;
    s3.condoFees = 200;
    s3.utilities -= 40;
    s3.insurance -= 10;
    s3.maintenance -= 1750;

    const s4 = this.scenarios[4];
    s4.title = 'House (absolute)';
    s4.price = 321800;
    s4.outfitting = 5000;
    s4.buyCostFlat += 1000;
    s4.utilities = 650;  // includes some non-utility stuff as well
  },

  methods: {
    newScenario() {
      this.scenarios.push(new Scenario(nextIndex++));
    },

    newScenarioFromStr(jsonObj: string) {
      const s = new Scenario(nextIndex++);
      const obj = JSON.parse(jsonObj);
      if (obj.check !== 'hfse0') {
        return;
      }

      s.title = obj.title;
      s.adjustResultForInflation = obj.adjustResultForInflation;
      s.price = obj.price;
      s.rent = obj.rent;
      s.condoFees = obj.condoFees;
      s.propertyTax = obj.propertyTax;
      s.utilities = obj.utilities;
      s.maintenance = obj.maintenance;
      s.insurance = obj.insurance;
      s.outfitting = obj.outfitting;
      s.buyCostFlat = obj.buyCostFlat;
      s.buyCostPct = obj.buyCostPct;
      s.sellCostFlat = obj.sellCostFlat;
      s.sellCostPct = obj.sellCostPct;
      s.downPaymentPct = obj.downPaymentPct;
      s.mortgageLength = obj.mortgageLength;
      s.mortgageTerm = obj.mortgageTerm;
      s.fthbSharePct = obj.fthbSharePct;
      s.sellAtYear = obj.sellAtYear;
      s.costGrowthRatePct = obj.costGrowthRatePct;

      s.mortgageInterestRatePct = VarNum.FromObj(obj.mortgageInterestRatePct);
      s.investmentRatePct = VarNum.FromObj(obj.investmentRatePct);
      s.houseAppreciationRatePct = VarNum.FromObj(obj.houseAppreciationRatePct);

      this.scenarios.push(s);
      this.tabs = 'tab-' + s.id;
    },

    pasteScenario() {
      const objStr = prompt('Paste Encoded Scenario', '');
      if (objStr != null) {
        this.newScenarioFromStr(objStr);
      }
    },

    deleteScenario(id: number) {
      const index = this.scenarios.findIndex((s) => s.id === id);
      // alert(this.scenarios[index].title);
      this.scenarios.splice(index, 1);
    },

    editScenario(scenario: Scenario) {
      const index = this.scenarios.findIndex((s) => s.id === scenario.id);
      this.scenarios.splice(index, 1, scenario);
    },
  },
});
